

const API_COMPONENTS = {
    // 获取登录验证码
    getLoginCode: {
        method: 'get',
        url: '/Login/verificationcode',
        config: {
            headers: {
                'Content-type': 'application/x-www-form-urlencoded',
            },
        }
    },
    // 查询所有检索方案
    querySearchPlan: {
        method: 'post',
        url: '/search/querySearchPlan',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 查询所有提取方案
    queryExtractPlan: {
        method: 'post',
        url: '/extract/queryExtractPlanAll',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 查询所有表单拦截规则
    queryFromRules: {
        method: 'post',
        url: '/fromrule/queryAll',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 查询检索方案实体数据
    querySearchPlanEntityVo: {
        method: 'post',
        url: '/search/querySearchPlanEntityVo',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 查询提取方案实体数据
    queryExtractPlanMainVo: {
        method: 'post',
        url: '/extract/queryExtractPlanMainVo',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 提取销售结算
    extractSusettleapply: {
        method: 'post',
        url: '/desynSusettleapply/extractSusettleapply',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 提取采购结算订单
    extractSynPssettleapply: {
        method: 'post',
        url: '/desynPssettleapply/extractSynPssettleapply',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 查询提取方案明细数据
    queryExtractPlanDetailVo: {
        method: 'post',
        url: '/extract/queryExtractPlanDetailVo',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    //根据采购订单id查询辅助信息
    getOrderId: {
        method: 'post',
        url: `/receive/getOrderId`,
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    //根据退补单id查询辅助信息
    getWosOrderId: {
        method: 'post',
        url: `/woApply/getWosupinfor`,
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    //根据退补单id查询记账辅助信息
    getWosAccountOrderId: {
        method: 'post',
        url: `/RrApply/getsuRgbkpinfor`,
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 退补记账
    getPsAccountTuibuList: {
        method: 'post',
        url: '/ReturnRepair/queryBill',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 新增退补记账
    addPsAccountTuibu: {
        method: 'post',
        url: '/ReturnRepair/addBill',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 预付款登记列表
    queryRegisterList: {
        method: 'post',
        url: '/register/query',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 新增预付款
    addRegister: {
        method: 'post',
        url: '/register/add',
        config: {
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
            },
        },
    },
    // 文件上传
    uploadFile: {
        method: 'post',
        url: '/upload/fileupload',
        config: {}
    },
    // 接口
    pageFormText: {
        method: 'post',
        url: '/jurconfig/jur',
        config: {}
    },
}

// 对象导出去
export default API_COMPONENTS